import * as React from 'react';
import { useEffect, useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { LoginModel, RegisterV2Model } from '../../../../models/AccountModels';
import PasswordField from '../../../../commonComponents/appForm/PasswordField';
import AppForm from '../../common/AppForm';
import PageTitle from '../../common/PageTitle';
import { getRegistrationDataFromLocalStorage, setRegistrationDataToLocalStorage } from '../../../../core/localStorage';
import { hasValue } from '../../../../lib/lib';
import PasswordRequirement from '../../common/PasswordRequirement';

const PasswordForm = ({ onSubmit }: Props) => {
	const methods = useForm();
	const { reset, control } = methods;
	const password = useWatch({ control, name: 'password', defaultValue: null });
	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmationPassword, setshowConfirmationPassword] = useState(false);

	useEffect(() => {
		const storedData = getRegistrationDataFromLocalStorage();
		if (storedData) {
			const parsedData: LoginModel = JSON.parse(storedData);
			reset(parsedData);
		}
	}, []);

	const handleSubmit = async (passwordModel: LoginModel) => {
		const storedData = getRegistrationDataFromLocalStorage();
		const existingData: RegisterV2Model = storedData ? JSON.parse(storedData) : {};

		// Update the password field
		const updatedData = { ...existingData, password: passwordModel.password };
		setRegistrationDataToLocalStorage(JSON.stringify(updatedData));

		onSubmit();
	};

	const handleTogglePasswordMask = () => {
		setShowPassword(!showPassword);
	};

	const handleToggleConfirmationPasswordMask = () => {
		setshowConfirmationPassword(!showConfirmationPassword);
	};

	return (
		<>
			<PageTitle title="Choose a password" />
			<PasswordRequirement />
			<AppForm methods={methods} onSubmit={handleSubmit} primaryButtonText="Continue" singleColumn>
				<PasswordField
					showPassword={showPassword}
					onTogglePasswordMask={handleTogglePasswordMask}
					required={false}
					validate
					customValidate={(value: string) => hasValue(value) || 'Please enter your password'}
				/>
				<PasswordField
					label="Confirm your password"
					name="confirmPassword"
					showPassword={showConfirmationPassword}
					onTogglePasswordMask={handleToggleConfirmationPasswordMask}
					required={false}
					validate
					customValidate={(value: string) => {
						if (!value) {
							return 'Please enter your password';
						}
						if (value !== password) {
							return "The passwords don't match. Please try again.";
						}
						return true;
					}}
				/>
			</AppForm>
		</>
	);
};

export default PasswordForm;

interface Props {
	onSubmit?: () => void;
}
